// extracted by mini-css-extract-plugin
export default {"bottomLinks":"help-drawer__bottomLinks___MeQ2-"};